import React,{Component} from "react";
import profileimage from "../../Images/profile.png";
import medicalrecord from "../../Images/medical-record.png";
import {tarbookService} from "../../services/tarbook.service";
import { ConvertToHtml, historypush } from "../../_helpers/utilities";
import Loader from "../../_helpers/Loader";
import eye from "../../Images/eye.png";
import { isStringEmpty } from "../../_helpers/string_helper";
import { helperText } from "../../_helpers/helpertext";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";

const validFileFormats = ["png","PNG", "jpeg", "JPEG", "jpg","JPG"];

class Profile extends Component{
  constructor(props){
    super(props);
    this.state={
      isLoading:false,
      userCode:'',
      userName:'',
      dob:'',
      nationality:'',
      email:'',
      contactNo:'',
      address:'',
      password:'',
      userId:'',
      grade:'',
      documentFile: null,
      folderName:'ProfileImage',
      profileImagePath:'',
      showSucessMessage:false,
      showFailureMessage:false,
      showPassword: false,
      userNameError:'',
      passwordError:'',
      roleId:0,
      mobileNo:'',
      message: EditorState.createEmpty(),
      errorMessage: {},
      hasMessage: false,
      isChangeRequestModelVisible:false,
      showSucessMessageForModel:false,
    }
  }

  componentDidMount=()=>{
    this.getUserprofileDataToDisplay();
  }

  toggleEye = () => {
    const currentState = this.state.showPassword;
    this.setState({ showPassword: !currentState });
  };

  /* <summary>
  date: 10-06-2022
  Name: VD
  description: To get all the details about the user who has logged in
  <summary>*/ 
  getUserprofileDataToDisplay=async()=>{
    try{
      this.setState({
        isLoading:true,
      })
      const userID = localStorage.getItem("UserID");
      const grade = localStorage.getItem("Grade");
      const Role = localStorage.getItem("RoleId");

      var response=await tarbookService.getUserProfileData(userID,grade);
      if(response.status===200){
        this.setState({
          userCode:response.data.userCode,
          userName:response.data.userName,
          dob:response.data.dob,
          nationality:response.data.nationality,
          email:response.data.email,
          contactNo:response.data.contactNo,
          mobileNo:response.data.mobileNo,
          address:response.data.address,
          password:response.data.password,
          profileImagePath:response.data.profileImagePath,
          roleId:Role,
        })
        // if(response.data.profileImagePath != ""){
        //   localStorage.setItem("Profileurl", response.data.profileImagePath);
        // }else{
        //   localStorage.setItem("Profileurl", profileimage);
        // }

      }else if(response.status===401){
        localStorage.clear();
        historypush('/login');
      }
      
      this.setState({
        isLoading:false,
        userId:userID,
        grade:grade,
      })
    }
    catch(ex){
      return "";
    }
  }

  onTextChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  /* <summary>
  date: 10-06-2022
  Name: VD
  description: To Change the password and user name of the user
  <summary>*/ 
  changePassword=async()=>{
    const{userCode,password,userId,grade}=this.state;
    try{
      if(this.validate()){
        var response = await tarbookService.addEditPassword(userCode,password,userId,grade);
        if(response.status===200){
          if(response.data===true){
            this.setState({
              showSucessMessage:true,
            })
          }else{
            this.setState({
              showFailureMessage:true,
            })
          }
          setTimeout(()=>{
            this.closeMessage()
          },3000)
        }else{
          alert('DB connection Error')
        }
      }
    }
    catch(ex){

    }
  }

  closeMessage=()=>{
    this.setState({
      showSucessMessage:false,
      showFailureMessage:false,
    })
  }

  validate=()=>{
    try{
      const { userCode, password } = this.state;
      
      var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

      let hasErrors = true;
      if (isStringEmpty(userCode)) {
        hasErrors = false;
        this.setState({ userNameError: helperText.loginPageText.emptyUserCodeError });
      }else{
        this.setState({userNameError: "",});
      }
      if (isStringEmpty(password)) {
        hasErrors = false;
        this.setState({passwordError: helperText.loginPageText.emptyPasswordError,});
      } else{
        this.setState({passwordError: "",});
        if(format.test(password)){
          if (password.length > 7) {
            this.setState({passwordError: "",});
            hasErrors = true;
          } else {
              this.setState({
                passwordError: helperText.resetPageText.passwordLength,
              });
              
              hasErrors = false;
          }
        }else{
          hasErrors = false;
            this.setState({
              passwordError: helperText.resetPageText.specialCharacterMissing,
            })
      }
      }
      return hasErrors;

    }catch(ex){

    }
    return true;
  }

  onFileChange = (e) => {
    if (!this.isValidFile(e.target.value)) {
      this.setState({
        fileInputKey: this.generateRandomString(),
        documentFile: null,
        errorFile: true,
        assignmentFileList:null,
      });
      return;
    }

    let file
  
    file = e.target.files[0];
    this.setState({
      errorFile: false,
      documentFile: file,
    },async()=>{
      this.addEditProfileImage();
    });
  };

  isValidFile = (value) => {
    //check if value is blank
    if (!value) return false;

    //regex to get file extension
    var re = /(?:\.([^.]+))?$/;

    //second item in the array will be the extension
    let ext = re.exec(value)[1];
    return validFileFormats.some((x) => x === ext);
  };

  /* <summary>
  date: 13-06-2022
  Name: VD
  description: To save or update the profile image that the user has uploaded
  <summary>*/ 
  addEditProfileImage=async()=>{
    try{
      const{
        documentFile,
        folderName,
        userId,
        grade,
      }=this.state;

      let data = new FormData();
      data.append("file", documentFile);
      data.append("folderName", folderName);
      data.append("userId", userId);
      data.append("grade",grade);

      var response = await tarbookService.AddEditProfileImage(data);
      if(response.status===200){
        localStorage.setItem("Profileurl", response.data.filePath);
        // this.getUserprofileDataToDisplay();
        window.location.reload();
      }

    }catch(ex){

    }
  }

  showChangeRequestModel=()=>{
    this.setState({isChangeRequestModelVisible:true})
  }

  HandleTextChange = (editorState, name) => {
    var empty = editorState.getCurrentContent().hasText();
    this.setState({
      [name]: editorState,
      errorMessage: {},
      hasMessage: empty,
    });
  };

  hideChangeRequestModel=()=>{
    this.setState({
      isChangeRequestModelVisible:false,
      message: EditorState.createEmpty(),
      errorMessage: {},
      showSucessMessageForModel:false,
    })
  }

  validateChangeRequestModel=()=>{
    const {hasMessage } = this.state;
    try {
      var isValid = true;
      if (hasMessage == false) isValid = false;

      if (hasMessage == false) {
        var error = this.state.errorMessage;
        error["emptymessage"] = helperText.profilePage.emptyMailMessage;
        this.setState({ errorMessage: error });
      }

      if(isValid){
        this.sendChangeRequestMail();
      }
    } catch (error) {}
  }

  /* <summary>
  date: 07-09-2022
  Name: VD
  description: This is used to send the mail that the member or the student has typed
  <summary>*/ 
  sendChangeRequestMail=async()=>{
    try{
      this.setState({isLoading:true});
      const {
        message,
        userName,
      } = this.state;
      var value = ConvertToHtml(message);
      var response = await tarbookService.SendChangeRequestMail(userName,value)
      if(response.status == 200){
        if(response.data == true){
          this.setState({
            showSucessMessageForModel:true,
          })
          setTimeout(()=>{
            this.hideChangeRequestModel()
          },3000)
        }
      }
      this.setState({isLoading:false});
    }catch(ex){
      return ""
    }
  }
    render(){
      const{
        userCode,
        userName,
        dob,
        nationality,
        email,
        contactNo,
        address,
        password,
        profileImagePath,
        showSucessMessage,
        showFailureMessage,
        isLoading,
        showPassword,
        userNameError,
        passwordError,
        roleId,
        mobileNo,
        message,
        isChangeRequestModelVisible,
        showSucessMessageForModel,
      }=this.state;
        return(
          <div className="member-body">
            {isLoading && <Loader />}
            <div className="about">
              <div className="container">
                <h3 className="heading-2">{roleId == 2? "IME(I) Student Area":"IME(I) Member Area"}</h3>
                <div className="profile-info">
                  <div className="row">
                    <div className="col-lg-4 col-md-5 col-sm-12">
                      <div className="image-profile">
                        <img src={profileImagePath === null ? profileimage : profileImagePath} alt="member-profile" />
                        <div className="icon-data">
                        <label htmlFor="myfile">
                          <i className="fa fa-plus plus-icon" style={{cursor: 'pointer'}} />
                        </label>
                        <input type="file" 
                          id="myfile" 
                          name="myfile" 
                          accept={".png,.jpg,.jpeg,.png,.jpg"}
                          style={{display: 'none', visibility: 'none'}} 
                          onChange={this.onFileChange}
                        />
                        <div id="display-image" />
                      </div>
                      </div>
                      <div className="profile-login">
                        <h5 className="mb-2">{roleId == 2? "User Code" : "Member Code"}</h5>
                        <input type="name" className="form-control mb-3" id="userCode" name="userCode" value={userCode} onChange={this.onTextChange} disabled={true} />
                        {!isStringEmpty(userNameError) && (
                          <small
                            id="emailHelp"
                            className="form-text"
                            style={{ color: "red" }}
                          >
                            {userNameError}
                          </small>
                          )}
                        <h5 className="mb-2">Password</h5>
                        <input type={showPassword ? "text" : "password"} className="form-control mb-1" id="password" name="password" value={password} onChange={this.onTextChange}  />
                        <img
                          style={{ left: "90%", marginTop: "-80px",cursor :'pointer',position:'relative' }}
                          src={eye}
                          onClick={this.toggleEye}
                        />{" "}
                        {!isStringEmpty(passwordError) && (
                          <small
                            id="emailHelp"
                            className="form-text"
                            style={{ color: "red",marginLeft:'-25px' }}
                          >
                            {passwordError}
                          </small>
                        )}
                        {showSucessMessage && (
                            <div id="thank_you" className="alert alert-success alert-dismissible" style={{ fontSize: '16px', marginTop:'-30px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                {/* <button type="button" className="btn-close" data-bs-dismiss="alert" /> */}
                                Password updated.
                            </div>
                        )}
                        {showFailureMessage && (
                            <div id="failure" className="alert" style={{fontSize: '16px', backgroundColor: '#e78c8c', borderColor: '#e47779', color: '#730f0f', marginTop:'-30px'}}>
                            {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">
                              ×
                            </a> */}
                            {/* <button type="button" className="btn-close" data-bs-dismiss="alert" /> */}
                            <strong>Error!</strong> Oops, something went wrong. Please try again later.
                          </div>
                        )}
                        <div className="profile-detail-mob"><div style={{display:'flex', justifyContent:'center'}}><button type="button" className="btn changebtn" onClick={this.changePassword} style={{marginTop:'8px'}}>Change Password</button></div></div>
                      </div>
                    </div>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                    {roleId == 2?
                      <div className="profile-personal-data" style={{margin:'0'}}>
                        <h4 className="mb-3" style={{fontSize:'27px'}}>Personal Information</h4>
                        <table className="table">
                          <tbody>
                            <tr>
                              <td style={{width: '170px'}}><h5>Name:</h5></td>
                              <td><p>{userName}</p></td>
                            </tr>
                            <tr>
                              <td><h5>Date of Birth:</h5></td>
                              <td><p>{dob}</p></td>
                            </tr>
                            <tr>
                              <td><h5>Nationality:</h5></td>
                              <td><p>{nationality}</p></td>
                            </tr>
                            <tr>
                              <td><h5>Email:</h5></td>
                              <td><p>{email}</p></td>
                            </tr>
                            <tr>
                              <td><h5>Contact no:</h5></td>
                              <td><p>{contactNo}</p></td>	
                            </tr>
                            <tr>
                              <td><h5>Address:</h5></td>
                              <td><p>{address}</p></td>	
                            </tr>
                            <tr>
                              <td><h5>Mobile Number:</h5></td>
                              <td><p>{mobileNo}</p></td>	
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      :

                      <div className="profile-personal-data" style={{margin:'0',padding:'100px 30px'}}>
                        <h4 className="mb-3">Personal Information</h4>
                        <table className="table">
                          <tbody> 
                            <tr>
                              <td style={{width: '170px'}}><h5>Grade:</h5></td>
                              <td><p>{localStorage.getItem("Grade")}</p></td>
                            </tr>
                            <tr>
                              <td style={{width: '170px'}}><h5>Name:</h5></td>
                              <td><p>{userName}</p></td>
                            </tr>
                            
                            <tr>
                              <td><h5>Email:</h5></td>
                              <td><p>{email}</p></td>
                            </tr>
                            
                            <tr>
                              <td><h5>Address:</h5></td>
                              <td><p>{address}</p></td>	
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      }
                      {roleId == 2 || roleId == 3?
                        <table style={{marginTop:'18px'}} className="profile-detail-mob">
                          <tbody>
                            <tr>
                              <td>
                                <button type="button" 
                                  className="btn" 
                                  style={{backgroundColor: '#115794', color: 'white'}} 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#myModal"
                                  onClick={()=>this.showChangeRequestModel()}
                                  >
                                  Change Request
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      :""}
                      {isChangeRequestModelVisible ?
                      <div className="modal update-unit-popup" id="myModal">
                      {isLoading && <Loader />}
                        <div className="modal-dialog modal-dialog-centered modal-md">
                          <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                              <h4 className="modal-title">Change Request</h4>
                              <button 
                                type="button" 
                                className="btn-close" 
                                data-bs-dismiss="modal"
                                onClick={()=>this.hideChangeRequestModel()}  
                              >X</button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="mb-3 mt-3">
                                  <h5 className="mb-2">Kindly change my following details:</h5>
                                  {/* <textarea type="text" id="body" name="message" style={{width: '100%', padding: '5px'}} required defaultValue={""} /> */}
                                  <Editor
                                  editorStyle={{maxHeight: 150,minHeight: 150, width: '100%',border:'1px solid' }}
                                  editorState={message}
                                  wrapperClassName="demo-wrapper sendtext-area-bg"
                                  editorClassName="editer-content"
                                  toolbarClassName="toolbar-class"
                                  onEditorStateChange={(editorState) =>
                                    this.HandleTextChange(editorState, "message")
                                  }
                                  toolbarHidden
                                  // toolbar={{
                                  //   options: ["inline"],
                                  //   inline: {
                                  //     inDropdown: false,
                                  //     options: ["bold", "italic", "underline"],
                                  //   },
                                  // }}
                                />
                                <div
                                  style={{
                                    display: this.state.errorMessage.emptymessage
                                      ? "contents"
                                      : "none",
                                    color: "red",
                                  }}
                                >
                                  {this.state.errorMessage.emptymessage}
                                </div>
                                {showSucessMessageForModel &&
                                  <div
                                  style={{
                                    color: "green",
                                  }}
                                >
                                  Your Change request mail has been sent.
                                </div>
                                }
                                </div>
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer">
                              <button type="submit" className="btn Cancel-btn"
                                onClick={()=>this.hideChangeRequestModel()}  
                              >Cancel</button>
                              <button type="button" 
                                className="btn Submit-btn" 
                                data-bs-dismiss="modal"
                                onClick={()=>this.validateChangeRequestModel()}
                              >
                                <a>Submit</a>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      :""}
                      {roleId == 2?
                      <div className="profile-personal-data profile-detail-mob">
                        <div className="row">
                          <div className="col-lg-3 col-md-6 col-sm-12">
                            <img src={medicalrecord} alt="medical record" />
                          </div>
                          <div className="col-lg-9 col-md-6 col-sm-12 medicalinfo">
                            <h5 className="medical-data mb-1">TAR Book Information</h5>
                            <a href="/tarbook">View</a>
                          </div>		
                        </div>
                      </div>
                      :""}
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-12 profile-login-tab profile-detail-tab" style={{marginTop:'20px'}}>
                     <div style ={{display:"flex", placeContent:"center"}}><button type="button" className="btn changebtn" onClick={this.changePassword}>Change Password</button></div>
                    </div>
                    <div className="col-lg-8 col-md-7 col-sm-12 profile-detail-tab">
                    {roleId == 2?
                        <table style={{margin:'0 auto'}}>
                          <tbody>
                            <tr>
                              <td>
                                <button type="button" 
                                  className="btn" 
                                  style={{backgroundColor: '#115794', color: 'white', marginTop:'18px'}} 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#myModal"
                                  onClick={()=>this.showChangeRequestModel()}
                                  >
                                  Change Request
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      :""}
                       {roleId == 3?
                        <table style={{marginTop:'18px'}}>
                          <tbody>
                            <tr>
                              <td>
                                <button type="button" 
                                  className="btn" 
                                  style={{backgroundColor: '#115794', color: 'white'}} 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#myModal"
                                  onClick={()=>this.showChangeRequestModel()}
                                  >
                                  Change Request
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      :""}
                      {roleId == 2?
                      <div className="profile-personal-data">
                        <div className="row">
                          <div className="col-lg-3 col-md-6 col-sm-12">
                            <img src={medicalrecord} alt="medical record" />
                          </div>
                          <div className="col-lg-9 col-md-6 col-sm-12 medicalinfo">
                            <h5 className="medical-data mb-1">TAR Book Information</h5>
                            <a href="/tarbook">View</a>
                          </div>		
                        </div>
                      </div>
                      :""}
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
    }
}

export default Profile;